import * as React from "react";

function History(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" {...props}>
      <path
        d="M3.798 7.357l-2.51-.153c1.8-4.75 6.965-7.454 12.002-6.11 5.364 1.433 8.55 6.917 7.117 12.25-1.434 5.332-6.945 8.494-12.31 7.061a10.036 10.036 0 01-7.347-8.17"
        stroke="#415466"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.75 6.75v4l2 2"
        stroke="#415466"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default History;
